import app from 'flarum/forum/app';
function normalizedDraftCount(value) {
  return typeof value === 'number' && Number.isFinite(value) ? Math.max(0, value) : 0;
}
export function getDraftCount() {
  return normalizedDraftCount(app.session.user?.draftCount?.());
}
export function setDraftCount(count) {
  const user = app.session.user;
  if (!user?.data?.attributes) {
    return;
  }
  user.data.attributes.draftCount = normalizedDraftCount(count);
}
export function adjustDraftCount(delta) {
  setDraftCount(getDraftCount() + delta);
}
flarum.reg.add('fof-drafts', 'forum/utils/draftCount', { getDraftCount: getDraftCount,setDraftCount: setDraftCount,adjustDraftCount: adjustDraftCount, });